import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { GlobalVariable } from '../helpers/settings';

@Injectable({
	providedIn: 'root'
})
export class JwtInterceptor implements HttpInterceptor {
	constructor(private authenticationService: AuthService) {}
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const user = this.authenticationService.userValue;
		if (!user) return next.handle(request);
		const auth = this.authenticationService.getAuth();
		const isLoggedIn = auth?.authToken;
		const isApiUrl = request.url.startsWith(GlobalVariable.server.host);
		if (isLoggedIn && isApiUrl) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${auth.authToken}`
				}
			});
		}

		return next.handle(request);
	}
}
